package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
enum class ImageType(val folder: String) {
    AVATAR("avatars"),
    BUSINESS("business"),
    COMMENTS("comments")
}